import apiRequest from './api.js';
import { now, Hour } from './util.js';

function lastFetchedTags() {
  const storedResult = localStorage.getItem('lastFetchedTags');
  if (storedResult) {
    return parseInt(storedResult, 10);
  }
  return 0;
}

function cachedTags() {
  try {
    return JSON.parse(localStorage.getItem('tags'));
  } catch (e) {
    return [];
  }
}

export async function fetchTags(refresh = false) {
  if (!refresh && now() - lastFetchedTags() < Hour) {
    return cachedTags();
  }
  const response = await apiRequest('/skewer/tags');
  if (!response.ok) {
    throw new Error(`${response.status}: ${response.statusText}`);
  }
  const result = await response.json();
  localStorage.setItem('lastFetchedTags', now());
  localStorage.setItem('tags', JSON.stringify(result));
  return result;
}

export async function suggestTags(rawInput) {
  const input = rawInput.trim().toLowerCase();
  if (input.length === 0) {
    return [];
  }

  const tags = await fetchTags();

  return tags.filter((t) => t.tag.toLowerCase().startsWith(input));
}
